export const DISPLAY_BIG = "A";
export const DISPLAY_MEDIUM = "B";
export const DISPLAY_SMALL = "C";
